export default __webpack_public_path__ + "static/media/img4.ea5c9d2e.jpg";